export type JobStatus = 'UPLOADING' | 'TRANSCRIBING' | 'ANALYZING' | 'COMPLETED' | 'FAILED';

export const ARTIFACTS = [
  'transcript',
  'summary',
  'todos',
  'todos-json',
  'bundle',
  'transcript-pdf',
  'summary-pdf',
  'todos-pdf',
  'bundle-pdf',
] as const;
export type ArtifactName = (typeof ARTIFACTS)[number];

export interface Job {
  jobId: string;
  fileName: string;
  status: JobStatus;
  createdAt: string;
  updatedAt: string;
  title?: string;
  todoCount?: number;
  durationSeconds?: number;
  speakerCount?: number;
  wordCount?: number;
  markerCount?: number;
  artifacts?: Partial<Record<ArtifactName, string>>;
  error?: string;
}

export const STATUS_LABEL: Record<JobStatus, string> = {
  UPLOADING: 'Wird hochgeladen',
  TRANSCRIBING: 'Wird transkribiert',
  ANALYZING: 'Wird ausgewertet',
  COMPLETED: 'Fertig',
  FAILED: 'Fehlgeschlagen',
};

export const IN_PROGRESS: JobStatus[] = ['UPLOADING', 'TRANSCRIBING', 'ANALYZING'];

/** A video call from meet.myuniq.ai, waiting to be turned into a protocol. */
export interface Call {
  roomId: string;
  roomName: string;
  startedAt: string;
  endedAt: string;
  durationSeconds: number;
  /** Seconds of audio a transcription would submit: the tracks added up. */
  billableSeconds: number;
  participants: string[];
  tracks: { key: string; participant: string; startedAtMs: number; endedAtMs: number }[];
  /** Everything playable: cameras, shared screens and the microphones. */
  media?: CallMedia[];
  /** Set once the call has been turned into a protocol. */
  jobId?: string;
}

/** A track of a call that can be played back. */
export interface CallMedia {
  key: string;
  participant: string;
  source: 'camera' | 'microphone' | 'screen_share' | 'screen_share_audio' | 'unknown';
  kind: 'audio' | 'video' | 'unknown';
  startedAtMs: number;
  endedAtMs: number;
}
